import { msg } from '../messages'
import * as Util from '../util'

export function requiredDomain(value: { id: string | number }) {
  if (Util.isEmpty(value) || value.id === null || value.id === undefined || value.id === '') {
    return msg('required', value)
  }
}
